import React from "react";

import { Icon, Tooltip } from "components";

// The Tooltip wrapper carries an inline `display: inline-block` that beats the stylesheet, so we put
// the class on the inner span. Hover is the only other way to read the hint, so we keep it focusable.
export const InfoTooltipIcon = ({ title, dataTestId = "info-tooltip-icon" }: { title: string; dataTestId?: string }) => (
  <Tooltip title={title} placement="top">
    <span className="scenario-analysis-info-icon" tabIndex={0} aria-label={title} data-testid={dataTestId}>
      <Icon iconName="tabler/info-circle" size="s" aria-hidden />
    </span>
  </Tooltip>
);
